export default {
  title: 'Informe MRR',
  fields: {
    name: 'Nombre',
    area: 'Área',
    mrr: 'MRR (neto)',
  },
  buttons: {
    download_report: 'Descargar informe',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos, actualice la página',
  },
};
